import React, { useEffect, useState } from 'react';

import block from 'propmods';

import { devicesApi } from '../../api';
import { useSettingsPageContext } from '../../context/settingsPageContext';
import { useCurrentAliceApp } from '../../hooks/useCurrentAliceApp';
import { useFetchingHandler } from '../../hooks/useFetchingHandler';
import { MarketDevice } from '../../model/devices';
import { DeviceLinkingInput } from '../DeviceLinkingInput/DeviceLinkingInput';
import { DeviceLinkingList } from '../DeviceLinkingList/DeviceLinkingList';
import { Loading } from '../Loading/Loading';

import './DeviceLinking.scss';

const b = block('DeviceLinking');

export const DeviceLinking: React.FC = () => {
    const skill = useCurrentAliceApp()!;
    const { isDraft, isEditable } = useSettingsPageContext();
    const [devices, setDevices] = useState<MarketDevice[]>([]);

    const [fetchDevices, state] = useFetchingHandler({
        handler: () => devicesApi.getDeviceList(skill.id, skill.channel, isDraft),
        onLoad: (devices) => setDevices(devices),
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => void fetchDevices(), []);

    const onDeviceAdd = (device: MarketDevice) => {
        setDevices([device, ...devices]);
    };

    const afterDeviceRemove = (deviceId: string) => {
        const newDevices = devices.filter((device) => device.marketId !== deviceId);

        setDevices(newDevices);
    };

    const disabled = !isEditable && !__appConfig.user.isAdmin;

    return (
        <div {...b()}>
            <div {...b('input')}>
                <DeviceLinkingInput onDeviceAdd={onDeviceAdd} disabled={disabled} devices={devices} />
            </div>
            {state === 'loading' ? (
                <Loading centered />
            ) : (
                <DeviceLinkingList devices={devices} afterDeviceRemove={afterDeviceRemove} disabled={disabled} />
            )}
        </div>
    );
};
